var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{attrs:{"linkify":false,"source":_vm._f("markdown")(_vm.formatted,_vm.$colors),"anchorAttributes":{target: '_blank'}}})}
var staticRenderFns = []

export { render, staticRenderFns }